import { Guid } from '../utils/guid';

export enum MessageLevel {
    ERROR,
    WARN,
    INFO,
    SUCCESS
}

export class FlashMessage {
    level: MessageLevel;
    message: string;

    displayThroughNavigation: boolean;
    autoClose: boolean;
    id: string = Guid.newGuid();

    constructor(level: MessageLevel, message: string, displayThroughNavigation = false, autoClose = false) {
        this.level = level;
        this.message = message;
        this.displayThroughNavigation = displayThroughNavigation;
        this.autoClose = autoClose;
    }
}
